export enum TimeBlockStatus {
    Available = 0,
    Occupied = 1,
    BlackedOut = 2,
}

